module.exports = __webpack_public_path__ + "img/interface OneB Studio_5.afe8c56b.jpg";